import { is, object } from "superstruct"

import { SurveyAnswer, SurveyQuestion } from "modules/NewClientSurvey/common/interface"

export function findQuestionChoiceByRef(
    questions: SurveyQuestion[],
    answers: Record<string, SurveyAnswer>,
    ref: string
) {
    const question = questions.find((question) => question.ref === ref)
    if (question === undefined) return
    const answer = answers[question.id]
    if (answer === undefined) return
    if (is(answer.value, object())) {
        const values = Object.keys(answer.value)
        return question.choices.filter((choice) => values.includes(choice.id))
    }
    return question.choices.find((choice) => choice.id === answer.value)
}
